import React, { Component } from 'react';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';
import queryUtils from 'app/common/react/components/growth/unauth/open/search/queryUtils';
import { Icon } from 'gestalt';
import { track } from 'app/common/lib/react/analytics';

const styles = {
  container: {
    textAlign: 'left',
    width: 'auto',
    backgroundColor: '#efefef',
    borderRadius: '4px',
    boxSizing: 'border-box',
    display: 'block',
    float: 'none',
    flex: 1,
    height: '40px',
    marginLeft: '16px',
    marginRight: '16px',
    overflow: 'auto',
    position: 'relative',
  },
  inputContainer: {
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
  },
  searchIcon: {
    marginLeft: '16px',
  },
  formInput: {
    background: 'transparent',
    border: '0',
    borderRadius: '3px',
    boxShadow: 'none',
    boxSizing: 'border-box',
    color: '#a7a7a7',
    fontSize: '16px',
    fontWeight: '600',
    height: '40px',
    lineHeight: '20px',
    MozOsxFontSmoothing: 'grayscale',
    outline: 'none',
    textAlign: 'left',
    WebkitFontSmoothing: 'antialiased',
    width: '100%',
    marginLeft: '11px',
  },
  formInputFocus: {
    color: '#333',
  },
};

export default class SearchBoxPlaceholder extends Component {
  componentDidUpdate() {
    const { focused } = this.props;
    if (focused) {
      this._input.focus();
    } else {
      this._input.blur();
    }
  }

  logNavigateClick = () => {
    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.SEARCH_BOX,
      element: PCONST.thrift.ElementType.SEARCH_BOX_TEXT_INPUT,
      view: PCONST.thrift.ViewType.SEARCH,
      viewParameter: PCONST.thrift.ViewParameterType.SEARCH_PINS,
    });
  };

  navigate = () => {
    const { text } = this.props;
    const query = text.trim();

    const encodedQuery = encodeURIComponent(query);
    let url = `/search/pins/?q=${encodedQuery}`;
    // Tokenize and construct
    const terms = queryUtils.tokenizeQuery(query);
    const tempQueryStates = terms.map((term) => ({
      term,
      type: 'typed',
    }));
    url += '&rs=typed';
    url += queryUtils.constructQueryStatesParams(tempQueryStates, null);
    window.location.assign(url);
  };

  handleChange = (e) => {
    const text = e.target.value;
    this.props.updateText(text);
  };

  handleFocus = () => {
    this.props.updateFocus(true);
  };

  handleBlur = () => {
    this.props.updateFocus(false);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.logNavigateClick();
    this.navigate();
  };

  render() {
    const { focused, text } = this.props;

    const placeholder = i18n._('Search for easy dinners, fashion, etc.');

    let inputStyle = styles.formInput;
    if (focused) {
      inputStyle = { ...inputStyle, ...styles.formInputFocus };
    }

    return (
      <div style={styles.container}>
        <form name="search" onSubmit={this.handleSubmit}>
          <div style={styles.inputContainer}>
            <div style={styles.searchIcon}>
              <Icon
                accessibilityLabel={i18n._('Search', 'Accessible label for the search icon')}
                icon="search"
                size={20}
              />
            </div>
            <input
              onBlur={this.handleBlur}
              onChange={this.handleChange}
              onFocus={this.handleFocus}
              placeholder={placeholder}
              ref={(ref) => {
                this._input = ref;
              }}
              style={inputStyle}
              value={text}
            />
          </div>
        </form>
      </div>
    );
  }
}

SearchBoxPlaceholder.propTypes = {
  focused: PropTypes.bool,
  updateFocus: PropTypes.func.isRequired,
  updateText: PropTypes.func.isRequired,
  text: PropTypes.string,
};
